import React, {useState, useEffect} from 'react';
import {Table, Spin} from 'antd';
import {useIntl} from 'react-intl';
const TableList = (props) => {
  const {
    loading,
    dataTable,
    count,
    size,
    columns,
    setOffset,
    setSize,
    isPagination,
    rowSelection,
    rowKey,
  } = props;
  const [searchText, setSearchText] = useState('');
  const intl = useIntl();
  const [current, setCurrent] = useState(1);

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const handleTableChange = async (page, pageSize) => {
    setCurrent(page);
    setOffset(page);
  };

  const handleSizeChange = async (current, size) => {
    setSize(size);
  };

  const handleShowTotal = (total, range) => {
    return `${range[0]}-${range[1]} ${intl.formatMessage({
      id: 'TITLE.OF',
    })} ${total} ${intl.formatMessage({id: 'TITLE.ITEM'})}`;
  };

  return (
    <Table
      {...props}
      rowKey={rowKey || 'id'}
      bordered
      style={{backgroundColor: '#fff', width: '100%'}}
      rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
      loading={loading}
      size='small'
      ellipsis='enable'
      pagination={
        isPagination
          ? {
              total: count,
              defaultPageSize: size,
              pageSizeOptions: [
                '10',
                '20',
                '50',
                '100',
                '200',
                '500',
                '1000',
                '2000',
                '5000',
                '10000',
                '15000',
                '20000',
                '25000',
                '30000',
                '40000',
                '50000',
              ],
              onChange: handleTableChange,
              showSizeChanger: true,
              onShowSizeChange: handleSizeChange,
              current,
              showTotal: handleShowTotal,
              locale: {items_per_page: `/ ${intl.formatMessage({id: 'TITLE.PAGE'})}`},
              size: 'default',
            }
          : {}
      }
      columns={columns.map((item) => ({...item}))}
      dataSource={dataTable}
      rowSelection={rowSelection}
    />
  );
};

export default TableList;
